module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Black-Hestia.827c204.woff";